// Libarary Class
import { Component, OnInit, ViewEncapsulation, Inject, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
const _ = require('lodash');
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { NgbDateStruct, NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { SeedFulfillmentService } from './../../../../services/seed/seed-fulfillment.service';
import { PlotSeedService } from './../../../../services/seed/plot-seed.service';
import { PlotSeedReleaseService } from './../../../../services/seed/plot-seed-release.service';

// Class
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';
import { CommonService } from '../../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { ShippingAvailabilityService } from '../../../../services/seed/reports/shipping-availability-report.service';
import { BranchPlantVM } from '../../../../models/ShippingAvailability/BranchPlantVM';
import { PlotSeedReleaseBreakdownViewSliderModelService } from '../plot-seed-release-breakdown-view/plot-seed-release-breakdown-view-slider-model.service';

@Component({
  selector: 'app-plot-seed-release-order',
  templateUrl: './plot-seed-release-order.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ],
  styleUrl: './plot-seed-release-order.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlotSeedReleaseOrderComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('maturityToSearch') maturityToSelect: NgSelectComponent;
  @ViewChild('maturityFromSearch') maturityFromSelect: NgSelectComponent;
  private subscription = new Array<Subscription>();
  subscriptionForReleaseLandingReload;
  submitedItem = false;
  branchPlantData: any = [];
  dashboardFilter: DashboardFilter;
  deliverToData: any;
  freightHandlingCodeData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  isOverride = false;
  orderViewtoggle = false;
  palletTypeData: any;
  releaseOrder: ReleaseOrder;
  requestTypeData: any;
  shipToData: any;
  displayedColumns: string[] = ['marketingBrand', 'variety', 'maturity', 'itemNumber', 'itemDescription', 'orderQty', 'remainingQty', 'availableQty', 'releaseQty', 'uom', 'iconsDisplay'];
  isInventoryVisible = false;
  cropYear: any;
  selectedDealer: any;
  deliverTo: any;
  shipToDataLoading: boolean;
  locationDataLoading = true;
  freightHandlingCodeDataLoading: boolean;
  branchDataLoading: boolean;
  requestTypeDataLoading: boolean;
  palletTypeLoading: boolean;
  canSaveData = false;
  canSaveAndReleaseOrder = false;
  palletArrayItems = new Array();
  accountId: any;
  branchList: object[];
  deliverToLoading: boolean;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  accountEmail: string;
  productLineId: string;
  isNotValid: any;
  column: any;
  selectedValue: any;
  enable: any;
  deliverList: any;
  editToolKit: any;
  selectedCount: any;
  isSearchClicked: any;
  productSearchFilter: any;
  productFilters: any;
  partialSearchValue = '';
  marketingMasterList: any = [];
  filterValueList: any = [];
  searchValue = '';
  productSegmentMasterList: any = [];
  productLineMasterList: any = [];
  productCategoryMasterList: any = [];
  hybridVarietyMasterList: any = [];
  seedSizeMasterList: any = [];
  packageSizeMasterList: any = [];
  treatmentMasterList: any = [];
  orderReleaseDS: MatTableDataSource<any>;
  dealerOrderItemList: any;
  errorsList: Array<string> = [];
  error = false;
  validation: Validation;
  releaseOrderListCopy: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  submitButtonClicked = false;
  isEditMode = false;
  releaseId = 0;
  datemodel: NgbDateStruct;
  dateFilter: any;
  hasChangeAdded = false;
  isReleased = false;
  expandedElement: any | null;
  accessTypeMode = false;
  isDeliveryInstrcutionAccess = false;
  userMenuAccessList: any;
  deliveryInstructionChangeSubscription: any;
  deliveryInstructionAddUpdateChangeSubscription: any;
  releasePalletItems: Array<Object> = [];
  inventoryTypeData: any;
  computeOption: Inventory = Inventory.Compute_All;
  InventoryErrorFlag: string;
  isDeliveryInstructionEmpty = true;
  deliveryInstructionsMasterList: any = [];
  productLineIds: Array<string> = [];
  releaseItemsLotsList: any;
  isWeightComputed = false;
  isComputeDisabled = true;
  totalPalletWeight: number;
  totalSeedWeight: number;
  totalComputedWeight: number;
  isEaEligible: boolean;
  shipToAccountCopy: number;
  isPalletSectionShow: boolean = true;
  selectedBranchPlantList: Array<BranchPlantVM> = [];
  previousPage: string;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  pickupOrderValue: string;
  // Search Type set Up fro grid
  searchTypeList: any[] = [
    { name: 'Hybrid Variety', value: 'Variety' },
    { name: 'Maturity', value: 'Maturity' }
  ];
  productLineData: any;
  freightHandlingCodeMasterData: any;
  freightHandlingCodePickupData: any;
  freightHandlingCodeNoPickupData: any;
  webOrderNumberData: any;
  salesManagerAccounts: any;
  isUserSalesManager: boolean = false;
  readOnlyAccess: boolean = false;
  disableDeliverTo = false;
  plotSeedLeadDate = 0;
  defaultRequestDate: Date = new Date();
  availableMaturityOptions: any[] = [];
  BRANCH_PLANT_ID: string = '501201';
  DEFAULT_PICKUP_FREIGHT_HANDLING_CODE: string = 'CPU';
  DEFAULT_NO_PICKUP_FREIGHT_HANDLING_CODE: string = 'PPD';
  orderHeaderId: number = 0;
  isLandingOrder: boolean = false;
  editFullAccess: boolean = false;
  isInventoryComputed: boolean = false;
  jdeVersionOrderType: any;
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private seedFulfillmentService: SeedFulfillmentService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    private config: NgbDatepickerConfig,
    private configDate: NgbCalendar,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private shippingAvailabilityService: ShippingAvailabilityService,
    private plotSeedReleaseBreakdownViewSliderModelService: PlotSeedReleaseBreakdownViewSliderModelService,
    private plotSeedService: PlotSeedService,
    private plotSeedReleaseService: PlotSeedReleaseService,
    private cdRef: ChangeDetectorRef) {
    this.dashboardFilter = new DashboardFilter();
    this.releaseOrder = new ReleaseOrder();
    this.validation = new Validation();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    this.subscriptionForReleaseLandingReload = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationStart) {
        if (!(e.url === '/plot-seed/plot-seed-release-landing')) {
          this.plotSeedReleaseService.setOldFilters(null);
        }
      }
    });
  }

  ngOnInit() {
    this.submitedItem = this.seedFulfillmentService.submitedItem;

    if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
      this.localStorageService.remove('plotSeedReleaseBreakdown');
    }
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      this.releaseOrder.CropYear = this.headerYear;
    }

    this.releaseOrder.CompanyCode = this.headerCompany;
    this.loaderService.setLoaderStatus(true);
    this.resetPalletAndWeight();
    this.productSearchFilter = this.previousPage === "SAR" ? this.searchTypeList[7].value : this.searchTypeList[0].value;
    this.bindDataSource([], true);
    this.resetProductFilter();
    this.loadMasterData();

    this.canSaveData = false;
    this.canSaveAndReleaseOrder = false;

    this.errorMsgs = new Array();

    this.accessTypeMode = false;

    //if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
    //  const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    //  if (evolveAccessData) {
    //    this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
    //    this.accessTypeMode = this.previousPage == "SAR" ? false : this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_TAB, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);

    //    const isActiveUser = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    //    if (isActiveUser.plotSeedLeadDay) {
    //      this.plotSeedLeadDate = isActiveUser.plotSeedLeadDay;

    //      this.setDefaultRequestDate();
    //    }
    //  }
    //}
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  setAndValidateDefaultData() {
    this.subscription.push(this.plotSeedReleaseService.plotSeedOrderHeaderId.subscribe(headerId => {
      if (headerId && headerId != 0) {
        this.orderHeaderId = headerId;
        this.isLandingOrder = true;
      }
      else {
        this.orderHeaderId = 0;
      }

      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (data !== null && data !== undefined && data.resultData.length > 0) {
          this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
          if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE)) {
            this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
            this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED_RELEASE, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
            if (!this.editFullAccess && (!this.orderHeaderId || this.orderHeaderId == 0) && headerId == 0) {
              this.router.navigate(['/cc/landing-data']);
            }
            else {
              this.getPlotSeedOrderInitialData();
            }
          } else {
            this.router.navigate(['/cc/landing-data']);
          }
          const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          if (isActiveUser.plotSeedLeadDay) {
            this.plotSeedLeadDate = isActiveUser.plotSeedLeadDay;

            this.setDefaultRequestDate();
          }
        }
      }
      // Set the default value
      if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
        this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      }
      this.errorMsgs = new Array();
    }));
  }

  setDefaultRequestDate() {
    var currentDate = this.addBusinessDays(new Date(), this.plotSeedLeadDate);
    const strCurrentDate = (new Date(currentDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');

    this.defaultRequestDate = new Date(strCurrentDate);

    const endDate = new Date(this.localStorageService.get(MasterConstants.CROP_YEAR_END_DATE));

    this.maxDate = endDate;
    this.minDate = this.defaultRequestDate;
  }

  addBusinessDays(startDate: Date, leadDays: number): Date {
    let result = new Date(startDate);

    // Special case: if leadDays = 0 and today is weekend → push to next Monday
    if (leadDays === 0 && (result.getDay() === 0 || result.getDay() === 6)) {
      do {
        result.setDate(result.getDate() + 1);
      } while (result.getDay() === 0 || result.getDay() === 6);
      return result;
    }

    // Normal case: add business days
    for (let i = 0; i < leadDays;) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        i++;
      }
    }

    return result;
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Get Plot Seed Initial Data
  getPlotSeedOrderInitialData() {
    this.releaseOrder.BranchPlant = this.BRANCH_PLANT_ID;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedReleaseService.getPlotSeedReleaseOrderHeaderData().subscribe((result: any) => {
      if (result) {  
        this.productLineData = result.productLineList;
        if (result.productLineList && result.productLineList.length == 1 && this.orderHeaderId == 0) {
          this.releaseOrder.ProductLine = result.productLineList[0].id;
          this.getSalesManagerAccounts();
        }
        let freightCodes = result.noPickupFreightHandlingCodes;
        this.freightHandlingCodeNoPickupData = this.freightHandlingCodeMasterData.filter(x => freightCodes.includes(x.id));
        this.freightHandlingCodePickupData = this.freightHandlingCodeMasterData.filter(x => x.id == this.DEFAULT_PICKUP_FREIGHT_HANDLING_CODE);
        this.freightHandlingCodeData = this.freightHandlingCodeNoPickupData
        this.releaseOrder.FreightHandlingCode = this.DEFAULT_NO_PICKUP_FREIGHT_HANDLING_CODE;
        this.jdeVersionOrderType = result.jdeVersionOrderType;
      } else {
        this.shipToDataLoading = false;
        this.locationDataLoading = false;
      }
      this.loaderService.setLoaderStatus(false);
      if (this.orderHeaderId > 0) {
        this.isEditMode = true;
        this.loadOrderDetails();
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
      this.locationDataLoading = false;
    }));
  }

  getProductLineChange() {
    this.salesManagerAccounts = null;
    this.releaseOrder.SalesManagerAccount = null;
    this.shipToData = [];
    this.releaseOrder.ShipToAccount = null;
    this.selectedDealer = null;
    this.deliverToData = [];
    this.releaseOrder.DeliverTo = null;
    this.deliverTo = null;
    this.releaseOrder.DeliverToAnotherLocation = false;
    this.webOrderNumberData = null;
    this.releaseOrder.WebOrderNumber = null;
    this.releaseOrder.OrderHeaderId = null;
    this.orderHeaderId = 0;
    this.releaseOrder.RequestedDate = null;
    this.availableMaturityOptions = null;
    this.releaseOrder.IsCustomerPickup = false;
    this.releaseOrder.DeliveryInstructionsCodes = null;
    this.releaseOrder.CustomerPO = null;
    this.setFreightHandlingCode();
    this.bindDataSource([], false);
    this.resetPalletAndWeight();
    this.isInventoryComputed = false;
    this.getSalesManagerAccounts();
  }

  getSalesManagerChange($event) {
    this.shipToData = [];
    this.releaseOrder.ShipToAccount = null;
    this.selectedDealer = null;
    this.deliverToData = [];
    this.releaseOrder.DeliverTo = null;
    this.deliverTo = null;
    this.releaseOrder.DeliverToAnotherLocation = false;
    this.webOrderNumberData = null;
    this.releaseOrder.WebOrderNumber = null;
    this.releaseOrder.OrderHeaderId = null;
    this.orderHeaderId = 0;
    this.releaseOrder.RequestedDate = null;
    this.bindDataSource([], false);
    this.availableMaturityOptions = null;
    this.releaseOrder.IsCustomerPickup = false;
    this.releaseOrder.DeliveryInstructionsCodes = null;
    this.releaseOrder.CustomerPO = null;
    this.setFreightHandlingCode();
    this.resetPalletAndWeight();
    this.isInventoryComputed = false;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { salesManagerUpdate: true });
    if ($event && $event.accountNumber) {
      this.getShipAscAccounts($event.accountNumber);
    }
  }

  getSalesManagerAccounts() {
    if (this.releaseOrder.ProductLine) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.plotSeedReleaseService.getPlotSeedSalesManagerAccounts(this.releaseOrder.ProductLine).subscribe(result => {
        this.salesManagerAccounts = result;
        this.loaderService.setLoaderStatus(false);
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
    }
  }

  getOrderNumbers() {
    if (this.releaseOrder.SalesManagerAccount && this.releaseOrder.ProductLine && this.releaseOrder.ShipToAccount) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.plotSeedReleaseService.getPlotSeedOrderNumbers(this.releaseOrder.SalesManagerAccount, this.releaseOrder.ShipToAccount, this.releaseOrder.ProductLine).subscribe(result => {
        this.webOrderNumberData = result;
        if (result && result.length == 1) {
          this.orderHeaderId = result[0].id;
          this.loadOrderDetails();
          this.isEditMode = true;
        }
        else {
          this.loaderService.setLoaderStatus(false);
        }
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
    }
    else {
      this.webOrderNumberData = null;
    }

  }

  getShipAscAccounts(accountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedReleaseService.getPlotSeedShipToAscAccounts(accountNumber, this.releaseOrder.ProductLine).subscribe(result => {
      if (result && result.length > 0) {
        this.shipToData = result;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  getShipTo($event) {
    if ($event && $event.accountType == "F") {
      this.disableDeliverTo = true;
    }
    else {
      this.disableDeliverTo = false;
    }
    this.selectedDealer = $event;
    this.deliverToData = [];
    this.releaseOrder.DeliverTo = null;
    this.deliverTo = null;
    this.releaseOrder.DeliverToAnotherLocation = false;
    this.webOrderNumberData = null;
    this.releaseOrder.WebOrderNumber = null;
    this.releaseOrder.OrderHeaderId = null;
    this.orderHeaderId = 0;
    this.releaseOrder.IsCustomerPickup = false;
    this.releaseOrder.RequestedDate = null;
    this.releaseOrder.DeliveryInstructionsCodes = null;
    this.releaseOrder.CustomerPO = null;
    this.setFreightHandlingCode();
    this.bindDataSource([], false);
    this.resetPalletAndWeight();
    this.isInventoryComputed = false;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { shiptoupdated: true });
    if ($event && $event.accountNumber) {
      this.getDeliverToAccounts($event);
    }
  }

  getDeliverToAccounts($event) {
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    if ($event && $event.accountNumber && $event.parentNumber) {
      this.getDeliverToAccountsListBasedOnShipto($event.accountNumber, $event.parentNumber);
    }
  }

  getDeliverToAccountsListBasedOnShipto(accountNumber, parentAccountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedService.getPlotSeedDeliverTo(accountNumber, parentAccountNumber).subscribe(result => {
      if (result && result.length > 0) {
        this.deliverToData = result;
      }
      this.loaderService.setLoaderStatus(false);
      this.getOrderNumbers();
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Deliver to change event add the object to show the deliver to address
  getDeliverToAccount($event) {
    this.deliverTo = $event;
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
  }

  removeDeliverTo() {
    this.releaseOrder.DeliverTo = null;
    this.deliverTo = null;
  }

  getOrderNumberChange($event) {
    this.orderHeaderId = 0;
    this.releaseOrder.OrderHeaderId = null; 
    this.releaseOrder.RequestedDate = null;
    this.availableMaturityOptions = null;
    this.releaseOrder.IsCustomerPickup = false;
    this.releaseOrder.DeliveryInstructionsCodes = null;
    this.releaseOrder.CustomerPO = null;
    this.setFreightHandlingCode();
    this.bindDataSource([], false);
    this.resetPalletAndWeight();
    this.isInventoryComputed = false;
    if ($event && $event.id) {
      this.orderHeaderId = $event.id;
      this.loadOrderDetails();
      this.isEditMode = true;
    }
    else {
      this.isEditMode = false;
    }
  }

  loadOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.plotSeedReleaseService.getPlotSeedOrderItemData(this.orderHeaderId).subscribe(result => {
      if (result) {

        if (this.isLandingOrder) {
          // Sales Manager
          const salesManagerDetails = {
            accountNumber: result.salesManagerAccounNumber,
            accountName: result.salesManagerAccountName,
            accountNameCityState: result.salesManagerAccounNumber + ' - ' + result.salesManagerAccountName
          };

          this.salesManagerAccounts = [salesManagerDetails];

          this.releaseOrder.SalesManagerAccount = result.salesManagerAccounNumber;

          // Ship To Account
          const accountDetails = {
            accountNumber: result.shipToAccount,
            address1: result.shipToAddress1,
            city: result.shipToCity,
            state: result.shipToState,
            zipCode: result.zipCode,
            accountNameCityState: result.accountName,
            accountType: result.accountType
          };

          this.shipToData = [accountDetails];
          this.selectedDealer = accountDetails;
          this.releaseOrder.ShipToAccount = result.shipToAccount;

          //// Product Line
          //const productLineDetails = {
          //  id: result.productLineId,
          //  value: result.productLine
          //};

          //this.productLineData = [productLineDetails];
          this.releaseOrder.ProductLine = result.productLineId;

          // Web Order Number
          const webOrderNumberDetails = {
            id: this.orderHeaderId,
            value: result.webOrderNumber
          };

          this.webOrderNumberData = [webOrderNumberDetails];
        }

        
        this.releaseOrder.WebOrderNumber = result.webOrderNumber;
        this.releaseOrder.OrderHeaderId = this.orderHeaderId;

        if (result.deliverToAccount) {
          // Create the object
          const deliverToDetails = {
            accountNumber: result.deliverToAccount,
            address1: result.deliverToAddress1,
            city: result.deliverToCity,
            state: result.deliverToState,
            zipCode: result.deliverToZipCode
          };
          this.deliverTo = deliverToDetails;
        }

        this.deliverToData = result.deliverTo;

        this.releaseOrder.DeliverTo = result.deliverToAccount;
        this.releaseOrder.DeliverToAnotherLocation = result.deliverToAccount > 0 ? true : false;

        if (new Date(result.requestDeliverDate) < this.defaultRequestDate) {
          this.releaseOrder.RequestedDate = this.defaultRequestDate;
        }
        else {
          this.releaseOrder.RequestedDate = result.requestDeliverDate;
        }

        this.releaseOrder.DeliveryInstructionsCodes = result.deliverInstructions;
        this.releaseOrder.IsCustomerPickup = result.customerPickup;

        if (this.releaseOrder.IsCustomerPickup) {
          this.freightHandlingCodeData = [...this.freightHandlingCodePickupData];
          this.releaseOrder.FreightHandlingCode = this.DEFAULT_PICKUP_FREIGHT_HANDLING_CODE;
        }
        else {
          this.freightHandlingCodeData = [...this.freightHandlingCodeNoPickupData];
          this.releaseOrder.FreightHandlingCode = this.DEFAULT_NO_PICKUP_FREIGHT_HANDLING_CODE;
        }

        this.releaseOrder.CustomerPO = result.customerPO;

        this.dealerOrderItemList = result.detailsData;
        let rowId: Number = 0;
        let marketingIds = [];
        const seen = new Set();
        this.dealerOrderItemList.forEach(product => {
          if (!seen.has(product.marketingBrand)) {
            seen.add(product.marketingBrand);
            marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
          }
          rowId = +rowId + 1;
          product.rowId = +rowId;
          product.orderQuantity = product.orderQuantity;
          //if (product.orderQuantity > 0) {
          //  hasQty = true;
          //}
          product.status = product.status;
          product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
        });
        marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
        this.marketingMasterList = marketingIds;
        this.availableMaturityOptions = result.availableMaturityOptions || [];
        this.bindDataSource(this.dealerOrderItemList, true);
        const hasAnyValidItem =
          this.dealerOrderItemList?.some(x => x.remainingQty > 0) ?? false;

        if (!hasAnyValidItem) {
          this.accessTypeMode = true;
          this.toastrService.error('Select a Plot Seed Order with at least one line having Remaining Qty greater than 0.');
        }
        else if (!this.editFullAccess) {
          this.accessTypeMode = true;
        }
        else {
          this.accessTypeMode = false;
        }
      }

      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Search button click handler
  onSearchClick() {
    // Validate maturity filters
    this.keepFilter();

    const fromVal = this.productFilters.MaturityFrom;
    const toVal = this.productFilters.MaturityTo;
    const fromSelected = fromVal !== null && fromVal !== undefined;
    const toSelected = toVal !== null && toVal !== undefined;

    // If MaturityTo is literal 'Blank' while MaturityFrom is numeric -> error per requirement
    if (toSelected && toVal === 'Blank' && fromSelected && fromVal !== 'Blank') {
      this.toastrService.error('Maturity From cannot be greater than Maturity To');
      // Clear invalid To selection
      this.productFilters.MaturityTo = null;
      this.clearNgSelectModel(this.maturityToSelect);
      return;
    }

    // If exactly one side is selected and the selected value is NOT the literal 'Blank', warn
    if ((fromSelected && !toSelected) || (!fromSelected && toSelected)) {
      const selectedVal = fromSelected ? fromVal : toVal;
      this.toastrService.warning('Maturity From and Maturity To both should be selected');
      return;
      // if selectedVal === 'Blank' -> allow, user is filtering for blank maturities (handled in applyAllFilters)
    }

    // If both sides selected and both are not 'Blank' strings, validate numeric range
    if (fromSelected && toSelected && fromVal !== 'Blank' && toVal !== 'Blank') {
      if (this.compareMaturityValues(fromVal, toVal) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');
        this.productFilters.MaturityTo = '';
        return;
      }
    }

    // Apply all filters
    this.applyAllFilters();
  }

  setFreightHandlingCode() {
    if (this.releaseOrder.IsCustomerPickup) {
      this.freightHandlingCodeData = [...this.freightHandlingCodePickupData];
      this.releaseOrder.FreightHandlingCode = this.DEFAULT_PICKUP_FREIGHT_HANDLING_CODE;
    }
    else {
      this.freightHandlingCodeData = [...this.freightHandlingCodeNoPickupData];
      this.releaseOrder.FreightHandlingCode = this.DEFAULT_NO_PICKUP_FREIGHT_HANDLING_CODE;
    }
  }

  // Get product list based on account selected
  getProductsList(branchPlant) {
    if (this.dealerOrderItemList && this.dealerOrderItemList.length > 0 && branchPlant) {
      this.isInventoryComputed = true;
      this.loaderService.setLoaderStatus(true);
      const newList = this.dealerOrderItemList.filter(x => x.remainingQty > 0).map(item => ({
        itemNumber: item.itemNumber,
        primaryUOM: item.primaryUOM,
        branchPlant: branchPlant
      }));

      this.subscription.push(this.plotSeedReleaseService.getPlotSeedReleaseData(newList).subscribe(result => {
        //this.productLineIds = new Array<string>();
        const releaseList = result;

        this.dealerOrderItemList.forEach(product => {
          const matched = releaseList.find(r => r.itemNumber === product.itemNumber);
          product.availableQty = matched ? matched.availableQty : 0;
        });

        //// Altering release qty preseved state back to its original state.
        //if (orderReleaseDSPrevState.length > 0) {
        //  orderReleaseDSPrevState.map((x) => {
        //    const item = this.dealerOrderItemList.filter(y => y.itemID == x.itemID);
        //    if (item.length > 0) {
        //      item[0]['releaseQty'] = x.releaseQty;
        //    }
        //  });
        //}

        this.bindDataSource(this.dealerOrderItemList, true);
        //this.enableDisableSave();
        //if (this.shipToAccountCopy != this.releaseOrder.ShipToAccount) {
        //  this.releaseOrder.ContactId = null;
        //  this.shipToAccountCopy = this.releaseOrder.ShipToAccount;

        //}

        this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
        this.enableDisableSave();
      })));
    }
  }

    // Freight handling code dropdown change event
    OnFreighthandlingCodeChange($event) {
      //this.validateUserinput('FreighthandlingCode', false);
      if ($event && this.isEditMode) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { freightHandlingCodeUpdated: true });
      }
    }

  openPlotReleaseBreakdown(data: any, isViewOrEdit: string) {
      this.plotSeedReleaseBreakdownViewSliderModelService.viewEditText = isViewOrEdit;
      this.plotSeedReleaseBreakdownViewSliderModelService.releaseOrderItem = data;
      this.plotSeedReleaseBreakdownViewSliderModelService.branchPlant = this.releaseOrder.BranchPlant;
      this.plotSeedReleaseBreakdownViewSliderModelService.activeSlider('plotSeedReleaseBreakdownView');
    }

    // compute pallet and seed weight
    computePalletAndSeedWeight() {
      //hide Add New Pallet for FreightHandlingCode = Parcel

        let isBulkNonBulk = false;
        const releaseOrderItems = this.dealerOrderItemList.filter(x => x.releaseQty > 0);
        if (releaseOrderItems && releaseOrderItems.length > 0) {
          const bulkNonBulkItems = releaseOrderItems.map(x => x.isBulk).filter((v, i, a) => a.indexOf(v) === i);
          if (bulkNonBulkItems && bulkNonBulkItems.length > 1) {
            isBulkNonBulk = true;
          }
        }

        if (isBulkNonBulk) {
          this.toastrService.error('There is requested quantiles entered for both bulk and non-bulk product. This line is for <Bulk/Packaged> product.');
        }
        else {
          this.loaderService.setLoaderStatus(true);
          this.getReleaseItems();
          this.getReleasePallet();
          this.subscription.push(this.plotSeedReleaseService.getPalletAndSeedWeight(this.releaseOrder).subscribe(result => {
            if (result) {
              //if (this.previousPage == "SAR") {
              //  this.releaseOrder.FreightHandlingCode = result.freightHandlingCode;
              //  this.releaseOrder.JDEVersion = result.jdeVersion;
              //  this.setOrderTypeType();
              //}
              if (this.releaseOrder.FreightHandlingCode && this.releaseOrder.FreightHandlingCode.toUpperCase() == 'PRC') {
                this.isPalletSectionShow = false;
              }
              else {
                this.isPalletSectionShow = true;
              }

              const errorMaxTruckLoad = 'Total weight for truckload is exceeded by';
              const errorMaxBulkSeedLoad = 'Total weight for Bulk Seed is exceeded by';
              const errorIndex = this.errorsList.findIndex(x => x.indexOf(errorMaxTruckLoad) !== -1 || x.indexOf(errorMaxBulkSeedLoad) !== -1);
              if (errorIndex >= 0) {
                this.errorsList.splice(this.errorsList.findIndex(x => x.indexOf(errorMaxTruckLoad) !== -1 || x.indexOf(errorMaxBulkSeedLoad) !== -1));
              }
              this.error = this.errorsList.length > 0;
              let hasErrors = [];
              hasErrors = result.releaseItemsList.filter(x => x.errors.length > 0);
              if (hasErrors.length > 0 || result.errors.length > 0) {
                if (result.errors.length > 0) {
                  this.errorsList.push(result.errors.find(x => x.indexOf(errorMaxTruckLoad) !== -1 || x.indexOf(errorMaxBulkSeedLoad) !== -1));
                  this.error = true;
                  $('.seedEfulfillmentOuter').scrollTop(0);
                }

                if (hasErrors.length > 0) {
                  this.dealerOrderItemList.filter(x => hasErrors.find(y => x.itemID == y.itemId)).forEach(data => {
                    data.lineErrors.errors = [];
                    const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemID);
                    if (itemErrors) {
                      itemErrors.errors.forEach(itemError => {
                        data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });
                        if (data.lineErrors.errors.length > 0) {
                          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                          this.errorMsgs.push(data.lineErrors);
                          this.getCommonErrors(this.errorMsgs);
                        }
                      });
                    }
                  });
                  this.isComputeDisabled = true;
                }
              } else {
                this.isComputeDisabled = true;
                this.isWeightComputed = true;
              }
              this.bindPalletsAndSeedsWeight(result);
              this.enableDisableSave();
            }
            this.loaderService.setLoaderStatus(false);
          }, (error => {
            this.loaderService.setLoaderStatus(false);
          })));
        }
    }

    bindPalletsAndSeedsWeight(releaseOrderData: any) {
      this.totalPalletWeight = releaseOrderData.totalPalletWeight;
      this.totalSeedWeight = releaseOrderData.totalSeedWeight;
      this.totalComputedWeight = this.totalPalletWeight + this.totalSeedWeight;

      this.palletArrayItems = [];
      releaseOrderData.releasePalletList.forEach(product => {
        const rowCounter = this.palletArrayItems.length;
        let palletType = product['palletType'];
        const filterPalletType = this.palletTypeData.filter(pt => pt.id == product['itemId'].toString());
        if (filterPalletType && filterPalletType.length > 0) {
          palletType = '';
        }

        this.palletArrayItems.push({
          rowId: rowCounter,
          itemId: product['itemId'].toString(),
          palletQuantity: product['quantity'],
          releaseId: product['releaseId'],
          releasePalletId: product['releasePalletId'],
          palletType: palletType
        });
      });
    }

  resetPalletAndWeight() {
    this.isOverride = false;
    this.totalPalletWeight = 0;
    this.totalSeedWeight = 0;
    this.totalComputedWeight = 0;
    this.palletArrayItems = [];
  }

    // Get the shipto and  deliver to for dropdown DeliverTo
    getShipToAndDeliverToData() {
      this.dashboardFilter.cropYear = this.headerYear;
      this.dashboardFilter.companyCode = this.headerCompany;
      this.subscription.push(this.seedFulfillmentService.getDeliverToList(MasterConstants.US_COMPANYCODE).subscribe(result => {
        this.deliverToData = result['accounts'];
        this.shipToData = result['accounts']?.filter(x => x.accountType != 'CD');
      }, error => LolLoggerService.error(error)));
    }

    // Load the master data for form
    loadMasterData() {
      if (this.localStorageService.get(MasterConstants.FREIGHT_HANDLING_CODE_MASTER_LIST)) {
        this.freightHandlingCodeMasterData = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_HANDLING_CODE_MASTER_LIST));
      }
      if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
        this.branchPlantData = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
        this.branchPlantData = this.branchPlantData.filter(x => x.data == this.headerCompany && x.id == this.BRANCH_PLANT_ID);
        this.branchPlantData.forEach(branch => {
          branch['description'] = branch['id'] + ' - ' + branch['value'];
        });
      }
      if (this.localStorageService.get(MasterConstants.PALLET_LINES_MASTER_LIST)) {
        this.palletTypeData = JSON.parse(this.localStorageService.get(MasterConstants.PALLET_LINES_MASTER_LIST));
      }

      this.loaderService.setLoaderStatus(false);

      this.setAndValidateDefaultData();
    }

    // Search the account details on shipto / Deliverto dropdown
    accountSearchFn(term: string, item: any) {
      term = term.toLocaleLowerCase();
      return item.accountName.toLocaleLowerCase().indexOf(term) > -1
        || item.accountNumber.toString().indexOf(term) > -1
        || item.address1.toLocaleLowerCase().indexOf(term) > -1
        || item.city.toLocaleLowerCase().indexOf(term) > -1
        || item.state.toLocaleLowerCase().indexOf(term) > -1
        || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
    }

    // set the selected product filter
    selectProductName($event) {
      // To check undefined
      if ($event) {
        const selectedValue = $event.target.value;
        if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
          // To add partial search value
          if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
            this.productFilters.ProductNameFilter = this.partialSearchValue;
          }
          // To add selected value
          else {
            this.productFilters.ProductNameFilter = selectedValue;
          }
        }
        else {
          // To add partial search value
          if (this.partialSearchValue.toString().trim().length > 2) {
            this.productFilters.ProductNameFilter = this.partialSearchValue;
          }
        }
      }
      else {
        this.resetProductFilter();
      }
      this.keepFilter();
    }

    // set the selected product filter
    selectItemNumber($event) {
      // To check undefined
      if ($event) {
        this.productFilters.ItemNumber = $event.target.value;
      }
      this.keepFilter();
    }

    getFilterData() {
      this.keepFilter();
      //this.applyFilterData(this.productFilters);
    }

    // Keep the selected filter in case of edit
    keepFilter() {
      if (this.filterValueList) {
        // Create filterValueList from Product Filters
        this.filterValueList = [];
        if (this.productFilters) {
          if (this.productFilters.Variety && this.productFilters.Variety != '') {
            this.filterValueList.push('Hybrid Variety : ' + this.productFilters.Variety);
          }
          if (this.productFilters.MaturityFrom && this.productFilters.MaturityFrom != '') {
            this.filterValueList.push('Maturity From : ' + this.productFilters.MaturityFrom);
          }
          if (this.productFilters.MaturityTo && this.productFilters.MaturityTo != '') {
            this.filterValueList.push('Maturity To : ' + this.productFilters.MaturityTo);
          }

          if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
            let strMB = '';
            this.productFilters.MarketingBrandList.forEach(x => {
              strMB = strMB + (x ? x : 'Blank') + ', ';
            });
            this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
          }
        }
      }

    }

    // Clear the selected filters
    clearAllFilter() {
      this.filterValueList = new Array();
      this.resetProductFilter();
      this.applyFilterData(this.productFilters);
    }

    // Clear single filter
    clearFilter(filterValue) {
      const index = this.filterValueList.indexOf(filterValue);
      if (index > -1) {
        this.filterValueList.splice(index, 1);
        // remove product filter
        this.removeProductFilter(filterValue);
        this.applyFilterData(this.productFilters);
        this.onSearchClick();
        if (this.filterValueList.length < 1) {
          // remove all filter
        }
      }
    }



    // To remove clear search filter
    removeProductFilter(filterValue) {
      const removeFilter = filterValue.split(' : ');
      const index = -1;
      switch (removeFilter[0].trim()) {
        case 'Maturity From':
          this.productFilters.MaturityFrom = null;
          break;
        case 'Maturity To':
          this.productFilters.MaturityTo = null;
          break;
        case 'Hybrid Variety':
          this.productFilters.Variety = '';
          break;
        default:
          break;
      }
    }

    // Combined filter application (for Search button)
    applyAllFilters(isCheckBox = false) {
      let filteredItems = [...this.dealerOrderItemList];

      // Variety / Brand filter
      if (this.productFilters.Variety && this.productFilters.Variety.trim()) {
        const searchTerm = this.productFilters.Variety.replace(/\s+/g, ' ').trim().toLowerCase();

        filteredItems = filteredItems.filter(item => {
          const brand = String(item.brand || item.Brand || '').toLowerCase();
          return brand.includes(searchTerm);
        });
      }

      // Maturity filter - support literal 'Blank' selection with special From semantics
      const fromVal = this.productFilters.MaturityFrom;
      const toVal = this.productFilters.MaturityTo;
      const fromSelected = fromVal !== null && fromVal !== undefined;
      const toSelected = toVal !== null && toVal !== undefined;

      if (fromSelected || toSelected) {
        // Case: From = 'Blank' and To is numeric -> include items with empty maturity OR maturities <= To
        if (fromVal === 'Blank' && toSelected && toVal !== 'Blank') {
          const toValue = this.extractMaturityNumericValue(toVal);
          filteredItems = filteredItems.filter(item => {
            if (!item.maturity || item.maturity.trim() === '') return true; // include blanks
            const itemVal = this.extractMaturityNumericValue(item.maturity);
            return !isNaN(itemVal) && !isNaN(toValue) && itemVal <= toValue;
          });
        }
        // Case: either side explicitly 'Blank' (and above handled), but both blank -> show blanks only
        else if (fromVal === 'Blank' || toVal === 'Blank') {
          filteredItems = filteredItems.filter(item => !item.maturity || item.maturity.trim() === '');
        }
        // Case: both numeric -> normal numeric range
        else if (fromSelected && toSelected) {
          const fromValue = this.extractMaturityNumericValue(fromVal);
          const toValue = this.extractMaturityNumericValue(toVal);

          filteredItems = filteredItems.filter(item => {
            const itemMaturityValue = this.extractMaturityNumericValue(item.maturity);
            return (
              !isNaN(itemMaturityValue) &&
              !isNaN(fromValue) &&
              !isNaN(toValue) &&
              itemMaturityValue >= fromValue &&
              itemMaturityValue <= toValue
            );
          });
        }
      }

      if (!isCheckBox && filteredItems.length === 0) {
        this.toastrService.info('No items match the selected filters');
      }

      this.bindDataSource(filteredItems, false);
    }

    // Compare maturity values (e.g., "0.9-1.4" vs "2.0-2.4")
    compareMaturityValues(from: string, to: string): number {
      const fromValue = this.extractMaturityNumericValue(from);
      const toValue = this.extractMaturityNumericValue(to);
      return fromValue - toValue;
    }

    // Extract numeric value from maturity string (e.g., "0.9-1.4" -> 0.9)
    extractMaturityNumericValue(maturityString: string): number {
      if (maturityString === null || maturityString === undefined) return NaN;
      const s = String(maturityString).trim();
      if (s === '') return NaN;

      const parts = s.split('-');
      if (!parts || parts.length === 0) return NaN;

      const parsed = parseFloat(parts[0]);
      return isNaN(parsed) ? NaN : parsed;
    }

    checkAvailability(isAvailabilityChecked: boolean) {
      this.productFilters.IsAvailabilityChecked = isAvailabilityChecked;
      this.keepFilter();
    }

    // Reset the filters
    resetProductFilter() {
      this.productFilters = {
        Variety: '',
        MaturityFrom: null,
        MaturityTo: null
      };
      this.bindDataSource(this.dealerOrderItemList, true);
    }

    // Search based on filter type
    filterSearchFn(term: string, item: any) {
      term = term.toLocaleLowerCase();
      return item.value.toLocaleLowerCase().indexOf(term) > -1;
    }

    // Set initial value for filter
    partialSearch(searchValue: string) {
      if (searchValue != undefined) {
        this.partialSearchValue = searchValue;
      }
    }

    // Filter grid data on type
    applyFilterData(filterValue: any) {
      this.orderReleaseDS.filter = filterValue;
    }

  private clearNgSelectModel(select: NgSelectComponent) {
    if (!select) { return; }
    const anySelect = select as any;
    try {
      if (typeof anySelect.clearModel === 'function') {
        anySelect.clearModel();
      }
      if (typeof anySelect.clear === 'function') {
        anySelect.clear();
      }
      // fallback: clear selectedItems / selectedValue if present
      if ('selectedItems' in anySelect) {
        anySelect.selectedItems = [];
      }
      if ('selectedValue' in anySelect) {
        anySelect.selectedValue = null;
      }
    } catch (e) {
      // noop - best-effort clear
    }
    // ensure Angular picks up the change
    this.cdRef.detectChanges();
  }

  // Dealer unit change and validation
  dealerUnitChange(action: string, productItem: any) {
    // To do
    if (action == 'decrease') {
      const decValue = +productItem.releaseQty - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.releaseQty;
        productItem.releaseQty = Math.floor(productItem.releaseQty / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.releaseQty) {
          productItem.releaseQty = (+productItem.releaseQty > +productItem.conv ? +productItem.releaseQty - +productItem.conv : 0);
        }
      }
      else {
        productItem.releaseQty = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.releaseQty;
      productItem.releaseQty = Math.ceil(productItem.releaseQty / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.releaseQty) {
        productItem.releaseQty = (+productItem.releaseQty + +productItem.conv);
      }
    }

    this.validateLineItem(productItem, 'releaseUnit');
    if (this.errorMsgs.length <= 0 && action == 'increase') {
      //this.selectDeliveryInstruction();
    }
  }

  // Enable Disable save button based on if any product have a quantity > 0
  enableDisableSave() {
    // Commented this condition due to - USerStory#44882

    if (this.isWeightComputed) {
      if (_.filter(this.dealerOrderItemList, item => item.releaseQty > 0).length > 0) {
        this.canSaveData = true;
        this.canSaveAndReleaseOrder = true;
      } else {
        // this.canSaveData = false;
        this.canSaveAndReleaseOrder = false;
      }
    }
    else {
      this.canSaveData = false;
      this.canSaveAndReleaseOrder = false;
    }
  }

  // Enable Disable compute button based on if any product have a quantity > 0
  enableDisableCompute() {
    this.isWeightComputed = false;
    this.isComputeDisabled = true;
    if (_.filter(this.dealerOrderItemList, item => item.releaseQty > 0).length > 0) {
      const productList = this.orderReleaseDS.data.find(x => x.releaseQty > 0);
      if (productList && this.errorMsgs.length <= 0) {
        this.isComputeDisabled = false;
      }
    }
  }

  get isValidOrder(): boolean {
    return !(
      this.releaseOrder.ProductLine &&
      this.releaseOrder.ShipToAccount &&
      this.releaseOrder.SalesManagerAccount &&
      this.releaseOrder.OrderHeaderId &&
      !this.accessTypeMode
    );
  }

  //// Bind data source
  //bindDataSource(orderList: any, isClone: boolean) {
  //  if (orderList && orderList != null) {
  //    if (orderList.length > 0) {
  //      let rowId: Number = 0;
  //      orderList.forEach(x => {
  //        const orderNo = +x.jdeReleaseOrderNumber;
  //        if (orderNo > 0) {
  //          this.isReleased = true;
  //        }
  //        rowId = +rowId + 1;
  //        x.rowId = +rowId;
  //      });
  //    } else {
  //      this.canSaveData = false;
  //      this.canSaveAndReleaseOrder = false;
  //    }

  //    if (this.previousPage == "SAR") {
  //      const sarItemNumber = this.selectedBranchPlantList.map(x => x.itemNumber);
  //      this.orderReleaseDS = new MatTableDataSource(orderList.filter(item => sarItemNumber.includes(item.itemNumber)));
  //    }
  //    else {
  //      this.orderReleaseDS = new MatTableDataSource(orderList);
  //    }
  //    this.enableDisableCompute();
  //    this.orderReleaseDS.filterPredicate = (data: any, filter: any) => {
  //      if (data.productNameFilter == null || data.productNameFilter == 'undefined') {
  //        data.productNameFilter = '';
  //      }

  //      if ((filter.ProductNameFilter == null || data.productNameFilter.toLowerCase().indexOf(filter.ProductNameFilter.toLowerCase()) > -1)
  //        && (filter.itemNumber == null || data.itemNumber.toLowerCase().indexOf(filter.itemNumber.toLowerCase()) > -1)
  //        && (filter.ProductSegmentList.length == 0 || filter.ProductSegmentList.indexOf(data.productSegment) > -1)
  //        && (filter.ProductLineList.length == 0 || (filter.ProductLineList.indexOf(data.productLine) > -1))
  //        && (filter.ProductCategoryList.length == 0 || filter.ProductCategoryList.indexOf(data.technology) > -1)
  //        && (filter.MarketingBrandList.length == 0 || filter.MarketingBrandList.indexOf(data.marketingBrand) > -1)
  //        && (filter.HybridVarietyList.length == 0 || filter.HybridVarietyList.indexOf(data.hybridVariety) > -1)
  //        && (filter.SeedSizeList.length == 0 || filter.SeedSizeList.indexOf(data.seedSize) > -1)
  //        && (filter.PackageSizeList.length == 0 || filter.PackageSizeList.indexOf(data.packageSize) > -1)
  //        && (filter.TreatmentList.length == 0 || filter.TreatmentList.indexOf(data.treatment) > -1)
  //        && (filter.IsAvailabilityChecked == false || data.inventoryQty > 0)) {
  //        return true;
  //      }
  //      else {
  //        return false;
  //      }
  //    };

  //    this.applyFilterData(this.productFilters);
  //  }

  //  // created deep copy
  //  if (isClone) {
  //    this.releaseOrderListCopy = JSON.parse(JSON.stringify(orderList));
  //  }
  //}

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      //orderList = this.plotSeedOrder.IsLinesGreaterThanZero
      //  ? orderList.filter(x => x.orderQuantity > 0)
      //  : orderList;

      this.orderReleaseDS = new MatTableDataSource(orderList);

      this.orderReleaseDS.filterPredicate = (data: any, filter: any) => {
        if (data.variety == null || data.variety == 'undefined') {
          data.variety = '';
        }
        if ((filter.Variety == null || data.variety.toLowerCase().indexOf(filter.Variety.toLowerCase()) > -1)) {
          return true;
        }
        else {
          return false;
        }
      };
      this.enableDisableCompute();
      this.enableDisableSave();
      // this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.releaseOrderListCopy = JSON.parse(JSON.stringify(orderList));
      }

    }
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
  }

  // Delivery instruction key up event
  deliveryInstructionChange() {
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliveryInstructionsUpdated: true });
    }
  }

  // Add new Item to the palletType Table
  addPalletType() {
    if (this.palletTypeData.length === 0) {
      this.toastrService.info('No Pallet Line data available for addition.');
      return;
    } else {
      const rowCounter = this.palletArrayItems.length;
      this.palletArrayItems.push({
        rowId: rowCounter,
        itemId: new Number(),
        palletQuantity: 0,
        releaseId: 0,
        releasePalletId: 0,
        palletType: ''
      });
    }
  }

  setPalletItem($event, rowId, palletQuantity) {
    this.palletArrayItems.forEach(pallet => {
      if (pallet.rowId == rowId) {
        pallet.rowId = rowId;
        pallet.itemId = $event.id;
        pallet.palletQuantity = palletQuantity;
      }
    });
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  palletQuantityChange(rowId, palletQuantity) {
    this.palletArrayItems.forEach(pallet => {
      if (pallet.rowId == rowId) {
        pallet.rowId = rowId;
        pallet.palletQuantity = palletQuantity;
      }
    });
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  // Validate date
  validateDate($event) {
    const currentDate = new Date();
    if ($event.value < currentDate) {
      this.releaseOrder.RequestedDate = currentDate;
      if (this.isEditMode) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { requestedDateUpdated: true });
      }
    }
  }

  // Place release order
  placeReleaseOrder() {
    this.getReleaseItems();
    this.getReleasePallet();
    this.subscription.push(this.seedFulfillmentService.addUpdateReleaseOrder(this.releaseOrder).subscribe((result: any) => {
      if (result.errors.length > 0) {
        this.loaderService.setLoaderStatus(false);
        result.errors.forEach(x => {
          this.toastrService.error(x);
          return false;
        });
      }
      else {
        if (result.releaseId > 0) {
          if (this.isEditMode) {
            this.toastrService.success('Release Order #' + result.releaseId + ' updated successfully.');
          } else {
            this.toastrService.success('Release Order #' + result.releaseId + ' saved successfully.');
          }

          this.navigateToReleaseLanding();
        }
        else {
          this.dealerOrderItemList.forEach(data => {
            data.lineErrors.errors = [];
            const matchedItem = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (matchedItem) {
              data.availableUnits = matchedItem.availableUnits;
              data.remainingQty = matchedItem.remainingQty;
              data.inventoryQty = matchedItem.inventoryQty;
            }

            const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemID);
            if (itemErrors) {
              itemErrors.errors.forEach(itemError => {
                data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                if (data.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                  this.errorMsgs.push(data.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });

          this.releaseOrderListCopy.forEach(item => {
            const newLineValue = this.dealerOrderItemList.filter(x => x.rowId == item.rowId)[0];
            item.availableUnits = newLineValue.availableUnits;
            item.inventoryQty = newLineValue.inventoryQty;
            item.remainingQty = newLineValue.remainingQty;
            item.lineErrors.errors = [];
          });
          this.bindDataSource(this.dealerOrderItemList, false);
        }
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get release items for a product to be saved/updated
  getReleaseItems() {
    this.loaderService.setLoaderStatus(true);
    this.releaseOrder.ReleaseItemsList = new Array();
    this.releaseOrder.ReleaseItemsLots = new Array();
    this.releaseOrder.isOverrideOn = this.isOverride;
    let seedFulfillmentBreakdownLots;
    if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
      seedFulfillmentBreakdownLots = JSON.parse(this.localStorageService.get('plotSeedReleaseBreakdown'));
    }

    this.releaseOrder.OrderHeaderId = this.orderHeaderId;
    this.releaseOrder.PickupOrder = '';
    this.releaseOrder.IsBulk = 'N';

    var shipToAccountData =  this.shipToData.find(x => x.accountNumber == this.releaseOrder.ShipToAccount);

    this.releaseOrder.JDEOrderType = shipToAccountData.accountType == 'F' ? 'ST' : 'S6';

    var jdeVersion = this.jdeVersionOrderType.find(x => x.id == this.releaseOrder.JDEOrderType);

    this.releaseOrder.JDEVersion = jdeVersion.value;

    this.dealerOrderItemList.forEach(product => {
      let releaseItem: ReleaseItem;
      releaseItem = new ReleaseItem();
      releaseItem.ReleaseItemId = 0;
      releaseItem.OrderDetailID = product.orderDetailId;
      releaseItem.ItemId = product.itemId;
      releaseItem.Quantity = product.releaseQty;
      releaseItem.UOM = product.uom;
      releaseItem.InventoryQty = product.availableQty;
      releaseItem.ItemNumber = product.itemNumber;
      releaseItem.Status = 'A';
      releaseItem.ProductLineId = product.productLineId;
      releaseItem.IsBulk = product.isBulk;
      releaseItem.IsCBOX = product.isCBOX;
      releaseItem.PackageSize = product.packageSize;
      releaseItem.PackageSizeId = product.packageSizeId;
      this.releaseOrder.ReleaseItemsList.push(releaseItem);
      if (seedFulfillmentBreakdownLots) {
        const releaseItemsLotsSettings = seedFulfillmentBreakdownLots.filter(lots => lots.itemNumber === product.itemNumber && lots.lotLocationReleaseQuantity > 0);
        if (releaseItemsLotsSettings && releaseItemsLotsSettings.length > 0) {
          releaseItemsLotsSettings.forEach(lotSettings => {
            const releaseItemLot = new ReleaseItemsLots();
            releaseItemLot.itemId = product.itemID;
            releaseItemLot.location = lotSettings.location;
            releaseItemLot.lotNumber = lotSettings.lot;
            releaseItemLot.productWeight = lotSettings.weight;
            releaseItemLot.quantity = lotSettings.lotLocationReleaseQuantity;
            releaseItemLot.releaseItemId = product.releaseItemId;
            releaseItemLot.itemNumber = lotSettings.itemNumber;

            this.releaseOrder.ReleaseItemsLots.push(releaseItemLot);
          });
        }
      }
    });

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
  }

  // Get release pallet for a product to be saved/updated
  getReleasePallet() {
    this.loaderService.setLoaderStatus(true);
    this.releaseOrder.ReleasePalletList = new Array();
    const items = this.releasePalletItems;
    this.palletArrayItems.forEach(pallet => {
      let releasePallet: ReleasePallet;
      releasePallet = new ReleasePallet();
      if (pallet.palletQuantity > 0 && pallet.itemId > 0) {
        releasePallet.ReleaseId = this.releaseId;
        releasePallet.ReleasePalletId = pallet.releasePalletId;
        releasePallet.ItemId = pallet.itemId;
        releasePallet.Quantity = pallet.palletQuantity;
        releasePallet.PalletType = pallet.palletType;
        this.releaseOrder.ReleasePalletList.push(releasePallet);
      }
    });
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
  }

  // Validate input
  validateInput(data: any, message: string) {
    if ((typeof (data) === 'undefined' || data === null || (data == '' && message.indexOf('Freight') <= 0))) {
      if (!(this.errorsList.indexOf(message) > -1)) {
        this.errorsList.push(message);
      }
      return true;
    } else {
      return false;
    }
  }

  // rest validations
  resetValidations() {
    this.validation.BranchPlant = false;
    this.validation.JDEVersion = false;
    this.validation.RequestedDate = false;
    this.validation.FreightHandlingCode = false;
  }

  // Reset page
  resetPageData() {
    if (this.isReleased) {
      this.navigateToReleaseLanding();
    }
    else {
      if (this.hasChangeAdded == true) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });
        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
            this.resetData();
          }
        }));
      } else {
        this.resetData();
      }
    }
  }

  // Reset data
  resetData() {
    this.shipToData = [];
    this.deliverToData = [];
    this.freightHandlingCodeData = [];
    this.requestTypeData = [];
    this.branchPlantData = [];
    this.releaseOrder = new ReleaseOrder();
    this.selectedDealer = undefined;
    this.deliverTo = undefined;
    this.bindDataSource([], false);
    this.accountEmail = '';
    this.revertAllChanges();
    this.resetValidations();
    this.error = false;
    this.ngOnInit();
  }

  // Popup on JDEOrder button click gets open
  placeJdeOrder() {
    this.submitButtonClicked = true;
   // this.validateUserinput('Both', true);
    if (!this.error && !(this.errorMsgs.length > 0)) {
      const title = 'Please confirm saving this request, and submission to create release order in ERP system.';
      const message = 'Once this request is released, it may not be changed.';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Confirm', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.placeJdeOrderRequest();
        }
      }));
    }
  }
  // Place JDE order request
  placeJdeOrderRequest() {
    this.getReleaseItems();
    this.getReleasePallet();
    this.releaseOrder.ReleaseItemsList = this.releaseOrder.ReleaseItemsList.filter(x => x.Quantity > 0);

    this.subscription.push(this.plotSeedReleaseService.placeJDEOrder(this.releaseOrder).subscribe((result: any) => {
      if (result.errors.length > 0) {
        this.loaderService.setLoaderStatus(false);
        result.errors.forEach(x => {
          this.toastrService.error(x);
          return false;
        });
      }
      else {
        if (result.releaseId > 0) {
          if (result.submitFailedMessage == 'OK') {
            this.toastrService.success('Release Successful ' + this.releaseOrder.JDEOrderType + '-' + result.jdeReleaseOrderNumber);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.navigateToReleaseLanding();
          }
          else {
            this.toastrService.error(result.submitFailedMessage);
          }
        }
        else {
          this.dealerOrderItemList.forEach(data => {
            data.lineErrors.errors = [];
            const matchedItem = result.releaseItemsList.find(result => result.itemId == data.itemId);
            if (matchedItem) {
              data.availableQty = matchedItem.availableQty;
              data.remainingQty = matchedItem.remainingQty;
            }

            const itemErrors = result.releaseItemsList.find(result => result.itemId == data.itemId);
            if (itemErrors) {
              itemErrors.errors.forEach(itemError => {
                data.lineErrors.errors.push({ id: itemError.id, error: itemError.error });

                if (data.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                  this.errorMsgs.push(data.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });

          this.releaseOrderListCopy.forEach(item => {
            const newLineValue = this.dealerOrderItemList.filter(x => x.rowId == item.rowId)[0];
            item.availableQty = newLineValue.availableQty;
            item.lineErrors.errors = [];
          });
          this.bindDataSource(this.dealerOrderItemList, false);
        }
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    this.isWeightComputed = false;
    let seedFulfillmentBreakdownLots;
    if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
      seedFulfillmentBreakdownLots = JSON.parse(this.localStorageService.get('plotSeedReleaseBreakdown'));
    }
    this.enableDisableSave();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productQuantityUpdated: true });

    const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId == item.rowId)[0];
    if (validateField != '') {
      if (validateField == 'releaseUnit') {
        let unitsToMatch = 0;
        if (this.isEditMode) {
          unitsToMatch = +(item.releaseQty - oldLineValue.releaseQty);
        }
        else {
          unitsToMatch = +(item.releaseQty);
        }

        if (item.availableQty < unitsToMatch || item.remainingQty < unitsToMatch) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          item.lineErrors.errors.push({
            id: 'availableUnits', error: 'Release Qty cannot be more than Remaining Qty and Available Qty.'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (unitsToMatch != 0 && unitsToMatch % item.conv != 0) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your Release Qty in multiples of ' + item.conv });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }

        if (seedFulfillmentBreakdownLots) {
          const releaseItemsLotsSettings = seedFulfillmentBreakdownLots.filter(lots => lots.itemNumber === item.itemNumber && lots.lotLocationReleaseQuantity > 0);
          if (releaseItemsLotsSettings && releaseItemsLotsSettings.length > 0) {
            let lotsReleaseQuantity = 0;
            releaseItemsLotsSettings.forEach(lotSettings => {
              lotsReleaseQuantity += lotSettings.lotLocationReleaseQuantity;
            });
            if (lotsReleaseQuantity != item.releaseQty) {
              item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'lotsReleaseQuantityMisMatch');
              item.lineErrors.errors.push({ id: 'lotsReleaseQuantityMisMatch', error: 'Lot location release quanity does not match with release quantity' });
            }
            else {
              item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'lotsReleaseQuantityMisMatch');
              this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
            }
          }
        }
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    this.enableDisableCompute();
    return item;
  }

  // Hide/show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.releaseOrderListCopy.length > 0 && this.orderReleaseDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.orderReleaseDS.data.findIndex(x => x.rowId == element.rowId);

        if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
          this.errorMsgs.filter(x => {
            if (x.errors[0].id == 'lotsReleaseQuantityMisMatch') {
              const seedFulfillmentLots = JSON.parse(this.localStorageService.get('plotSeedReleaseBreakdown'));
              const seedFulfillmentLotsFilterData = seedFulfillmentLots.filter(lots => lots.itemNumber !== element.itemNumber);
              this.localStorageService.remove('plotSeedReleaseBreakdown');
              this.localStorageService.set('plotSeedReleaseBreakdown', JSON.stringify(seedFulfillmentLotsFilterData));
            }
          });
        }

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.orderReleaseDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.bindDataSource(this.orderReleaseDS.data, false);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
        }

        this.index = 0;
        this.currentErrorRow = 1;
      }
      else {
        // To hide all errors after revert all changes
        this.orderReleaseDS.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            const index = x.lineErrors.rowId - 1;
            const oldLineValue = this.releaseOrderListCopy.filter(x => x.rowId - 1 == index)[0];

            if (this.orderReleaseDS.data[index].lineErrors.errors[0].id === 'lotsReleaseQuantityMisMatch'
              && this.localStorageService.get('plotSeedReleaseBreakdown')) {
              const seedFulfillmentLots = JSON.parse(this.localStorageService.get('plotSeedReleaseBreakdown'));
              const seedFulfillmentLotsFilterData = seedFulfillmentLots.filter(lots => lots.itemNumber !== this.orderReleaseDS.data[index].itemNumber);
              this.localStorageService.remove('plotSeedReleaseBreakdown');
              this.localStorageService.set('plotSeedReleaseBreakdown', JSON.stringify(seedFulfillmentLotsFilterData));
            }

            this.orderReleaseDS.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.dealerOrderItemList, false);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Revert all changes
  revertAllChanges() {
    this.index = 0;
    this.currentErrorRow = 1;
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enableDisableSave();
    this.enableDisableCompute();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }
  // Go to landing seed fulfillment page
  navigateToReleaseLanding() {
    this.router.navigate(['/plot-seed/plot-seed-release-landing']);
  }

  // Show details
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  computeInventory() {
    this.hideCommonError();
    this.getProductsList(this.releaseOrder.BranchPlant);
  }

  removePalletItem(index: number) {
    this.palletArrayItems.splice(index, 1);
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  toggleOverrideOnly() {
    this.isOverride = !this.isOverride;
    this.enableDisableCompute();
    this.enableDisableSave();
  }

  ngOnDestroy() {
    this.plotSeedReleaseService.setPlotSeedOrderId(null);
    this.subscription.forEach(subscription => subscription.unsubscribe());
    if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
      this.localStorageService.remove('plotSeedReleaseBreakdown');
    }
    if (this.subscriptionForReleaseLandingReload) {
      this.subscriptionForReleaseLandingReload.unsubscribe();
    }
  }
}
// Class model for Release
export class ReleaseOrder {
  BranchPlant: string;
  ReleaseId: number;
  CropYear: number;
  CompanyCode: string;
  DealerOrderId: number;
  JDEOrderType: string;
  JDEVersion: string;
  ShipToAccount: number;
  FreightHandlingCode: string;
  DeliverTo: number;
  RequestedDate: Date;
  DeliveryCode: string;
  DeliveryInstructionsCodes: string;
  DeliveryInstructionsNamePhone: string;
  DeliveryInstructions: string;
  ReleaseItemsList: Array<ReleaseItem> = [];
  JDEReleaseOrderNumber: number;
  CustomerPO: string;
  ReleasePalletList: Array<ReleasePallet> = [];
  ContactId: number;
  isOverrideOn = false;
  ReleaseItemsLots: Array<ReleaseItemsLots> = [];
  PickupOrder: string;
  IsBulk: string;
  ProductLine: string;
  SalesManagerAccount: number;
  WebOrderNumber: string;
  IsCustomerPickup: boolean;
  DeliverToAnotherLocation: boolean;
  OrderHeaderId: number;
}

// Class model for delivery instruction master drop down
export class DeliveryInstructionMaster {
  DeliveryCode: string;
  Description: string;
}

// Class model for delivery instruction master drop down
export class DeliveryInstructionProductLine {
  ProductLineId: string;
  Description: string;
}

// Class model for items list for lot
export class ItemsList {
  ItemNumber: string;
  BranchPlant: string;
  ItemUOM: string;
}

// Class model for Release Item
export class ReleaseItem {
  OrderDetailID: number;
  ReleaseItemId: number;
  ItemId: number;
  JDELineNumber: any;
  Quantity: any;
  UOM: string;
  InventoryQty: number;
  Status: string;
  ItemNumber: string;
  ProductLineId: string;
  IsBulk: string;
  IsCBOX: string;
  PackageSize: string;
  PackageSizeId: string;
}
// Class for Validation check
export class Validation {
  JDEVersion = false;
  BranchPlant = false;
  RequestedDate = false;
  FreightHandlingCode = false;
  PickupOrder = false;
}
// Class model for Release Pallet
export class ReleasePallet {
  ReleasePalletId: number;
  ReleaseId: number;
  ItemId: number;
  Quantity: number;
  PalletType: string;
}

enum Inventory {
  None = 0,
  Compute_All = 1,
  Available_To_Release = 2,
  Do_Not_Compute = 3
}
export class ReleaseItemsLots {
  itemId: number;
  releaseItemId: number;
  lotNumber: string;
  location: string;
  productWeight: number;
  quantity: number;
  itemNumber: string;
}
